<template lang="pug">
  .forms
    .form
      .h3.login
      template(v-for="i in 2" :key="i")
        .field-label
        .field-bar
      .button-bar
      .link-bar
    .separator
    .form
      .h3
      template(v-for="i in 5" :key="i")
        .field-label
        .field-bar
      .h4
      .checkbox-grid
        .checkbox-row(v-for="i in 18" :key="i")
          .checkbox-row-box
          .checkbox-row-label
      .h4
      .checkbox-grid
        .checkbox-row(v-for="i in 2" :key="i")
          .checkbox-row-box
          .checkbox-row-label
      .h4.newsletter
      .checkbox-grid.email
        .checkbox-row(v-for="i in 2" :key="i")
          .checkbox-row-box
          .checkbox-row-label
        .disclaimer
      .button-bar
      .disclaimer
</template>
<script setup lang="ts">
</script>
<style lang="scss" scoped>
@keyframes skeleton-loading {
  0% { background-color: $color-gray; }
  100% { background-color: $color-gray-light; }
}

%skeleton-bar {
  border-radius: $border-width-thick;
  animation: skeleton-loading 0.8s linear infinite alternate;
}

.forms {
  @include not-mobile() {
    display: flex;
  }
}

.separator {
  width: 1px;
  flex-shrink: 0;
  margin: 0 $space-m;
  align-self: stretch;
  height: $space-m;

  @include not-mobile() {
    height: auto;
    background-color: $color-gray-light;
    display: block;
  }

  @include large-xl() {
    margin: 0 $space-xxxl;
  }
}

.form {
  flex: 1;
  flex-basis: 50%;
}

.h3 {
  @extend %skeleton-bar;
  height: $size-xxl;
  width: 170px;
  margin-bottom: $space-s;

  &.login{
    width: 100px;
  }
}

.h4 {
  @extend %skeleton-bar;
  height: $size-xl;
  width: 180px;
  margin-bottom: $space-s;

  &.newsletter{
    width: 450px;
    max-width: 100%;
  }
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: $space-l;

  &.email {
    display: flex;
    flex-direction: column;
  }
}

.checkbox-row {
  display: flex;
  align-items: center;
  margin-bottom: $space-s;
}

.checkbox-row-box {
  flex-shrink: 0;
  width: $size-m;
  height: $size-m;
  margin-right: $space-xxs;
  border-radius: 2px;
  animation: skeleton-loading 0.8s linear infinite alternate;
}

.checkbox-row-label {
  @extend %skeleton-bar;
  height: $size-xs;
  width: 70%;
}

.disclaimer{
  @extend %skeleton-bar;
  height: $size-xs;
  width: 70%;
}

.field-label {
  @extend %skeleton-bar;
  height: $size-xs;
  width: 80px;
  margin-bottom: $space-xxs;
}

.field-bar {
  @extend %skeleton-bar;
  height: 42px;
  width: 100%;
  margin-bottom: $space-s;
}

.button-bar {
  @extend %skeleton-bar;
  height: 44px;
  width: 100%;
  margin-bottom: $space-s;
}

.link-bar {
  @extend %skeleton-bar;
  height: $size-xs;
  width: 160px;
  margin: 0 auto 0 auto;
}
</style>
